/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysQueContextMenuComponent } from './sysque-context-menu.component';

@NgModule({
  declarations: [SysQueContextMenuComponent],
  imports: [CommonModule],
  exports: [SysQueContextMenuComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueContextMenuModule {}
